export default __webpack_public_path__ + "static/media/Roboto-ThinItalic.3c0ec889.ttf";